import type { BulkEvent } from '@Common/types/analytics/bulk_events';
import type { AnalyticsEvent } from '@Common/types/analytics/event';

import { storeEvent } from '@Utils/analytics/storage';

/**
 * Queue an event for the next batch upload.
 *
 * Fire-and-forget by design: analytics must never be able to break a user flow, so every
 * failure here is swallowed.
 */
export const createAnalyticsEvent = (data: AnalyticsEvent): void => {
  try {
    const event: BulkEvent = {
      ...data,
      created_at: Date.now(),
      id: crypto.randomUUID(),
    };

    storeEvent(event);
  } catch {
    // never let event collection surface to the user
  }
};
